import { useEffect, useState } from 'react';

import { StatCard, StatsCardSkeleton } from '../../../../component/LeadsDashboardComponents/StatCard';
import { DealsPipelineStages } from '../../../../component/DealsDashboardComponents/DealsPipelineStages';
import { DealsByStageChart } from '../../../../component/DealsDashboardComponents/DealsByStageChart';
// import { DealsByCompanies } from '../../../../component/DealsDashboardComponents/DealsByCompanies';
import { TopDealsChart } from '../../../../component/DealsDashboardComponents/TopDealsChart';
import { DealsByCountry } from '../../../../component/DealsDashboardComponents/DealsByCountry';
import { RecentFollowUp } from '../../../../component/DealsDashboardComponents/RecentFollowUp';
import { RecentDealsTable } from '../../../../component/DealsDashboardComponents/RecentDealsTable';
import { useApiCall } from '../../../../component/custom-hooks/api-call';
import { CustomDropdown } from '../../../../component/ui/dropdown/CustomDropdown';
import { CustomDropdownButton } from '../../../../component/ui/dropdown/CustomDropdownButton';
import { CustomDropdownMenu } from '../../../../component/ui/dropdown/CustomDropdownMenu';
import { CustomDropdownMenuList } from '../../../../component/ui/dropdown/CustomDropdownMenuList';
import { Skeleton } from '@mui/material';
import InnerLoader from '../../../../component/ui/loader/inner-loader';
import { ReportIcon } from '../../../../component/DashboardComponent/icons';
import AreaLineChart from '../../../../component/DealsDashboardComponents/AreaLineChart';
import { Clock, Today, RoundArrowCircle, Clander, Exit, TeamAvailability } from '../../../../component/LeadsDashboardComponents/StatCardIcons';
import { ChartMainCard } from '../../../../component/LeadsDashboardComponents/ChartsHeader';
import DealsByCompanies from '../../../../component/DealsDashboardComponents/DealsByCompanies';
import { TodayFollowups } from '../../../../component/LeadsDashboardComponents/TodayFollowUps';

const View = "myDeals"

export default function DealDashboard() {
  const [dateRange] = useState('11/02/2026 - 11/02/2026');
  const [dateFilter, setDateFilter] = useState("this_month");

  const apiCall = useApiCall();

  const [overAllData, setOverAllData] = useState({});
  const [overAllLoading, setOverAllLoading] = useState(true);
  const [KPIData, setKPIData] = useState({})

  const getOverallData = async () => {
    setOverAllLoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `deals/deals-overview?view=${View}&date_range=${dateFilter}`,
      });
      setOverAllData(resp?.data);
      setKPIData(resp?.data?.kpi_card_data)
      setOverAllLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };


  const [followUpsData, setfollowUpsData] = useState([]);
  const [followUpsApiLoading, setFollowUpsApiLoading] = useState(false);

  const getFollowUpsData = async () => {
    setFollowUpsApiLoading(true);
    try {
      const resp = await apiCall({
        method: "get",
        url: `activities/get-dashboard-followups?view=${View}&time=${dateFilter}`,
      });
      setfollowUpsData(resp?.data);
      setFollowUpsApiLoading(false);
    } catch (error) {
      setFollowUpsApiLoading(false);
      console.warn("Error : ", error);
    } finally {
      setFollowUpsApiLoading(false);
    }
  };

  useEffect(() => {
    getOverallData();
    getFollowUpsData();
  }, [dateFilter]);


  const chartData = {
    categories:
      overAllData?.last_12_months_by_status_won_loss?.map(
        (list) => list?.month
      ),

    data: [
      {
        name: "Total Deals",
        color: "#3B82F6",
        data:
          overAllData?.last_12_months_by_status_won_loss?.map(
            (d) => d?.total_deal
          ),

        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(59,130,246,0.25)"],
            [1, "rgba(59,130,246,0.02)"],
          ],
        },
      },

      {
        name: "Won Deals",
        color: "#10B981",
        data:
          overAllData?.last_12_months_by_status_won_loss?.map(
            (d) => d?.won_deal
          ),

        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(16,185,129,0.25)"],
            [1, "rgba(16,185,129,0.02)"],
          ],
        },
      },

      {
        name: "Lost Deals",
        color: "#EF4444",
        data:
          overAllData?.last_12_months_by_status_won_loss?.map(
            (d) => d?.lost_deal
          ),

        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(239,68,68,0.25)"],
            [1, "rgba(239,68,68,0.02)"],
          ],
        },
      },
    ],
  };


  // console.log("chartData", chartData)
  return (
    <div className="h-full w-full overflow-auto p-5 flex flex-col">

      {!overAllLoading ? (
        <>
          {/* Header */}
          <div className="">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-3 gap-0">
              <div>

                <h1 className="text-[24px] font-bold">Deal Metrics</h1>
              </div>



              <div>
                <CustomDropdown
                  position="bottom-right"
                  className="myDropdown !w-[200px]"
                >
                  <CustomDropdownButton
                    arrow={true}
                    className="btnClass !w-[200px] !justify-between"
                  >
                    <h3 className="!text-[16px] capitalize">
                      {dateFilter.replace("_", " ")}
                    </h3>
                  </CustomDropdownButton>

                  <CustomDropdownMenu className="w-full">
                    {dateFilter !== "this_month" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("this_month")}
                      >
                        This Month
                      </CustomDropdownMenuList>
                    )}

                    {dateFilter !== "last_month" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("last_month")}
                      >
                        Last Month
                      </CustomDropdownMenuList>
                    )}
                    {dateFilter !== "this_quarter" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("this_quarter")}
                      >
                        This Quarter
                      </CustomDropdownMenuList>
                    )}
                    {dateFilter !== "this_year" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("this_year")}
                      >
                        This Year
                      </CustomDropdownMenuList>
                    )}
                    {dateFilter !== "all_time" && (
                      <CustomDropdownMenuList
                        onClick={() => setDateFilter("all_time")}
                      >
                        All Time
                      </CustomDropdownMenuList>
                    )}
                  </CustomDropdownMenu>
                </CustomDropdown>
              </div>
            </div>
          </div>

          <div className='w-full h-full'>
            {/* First Row - Pipeline and Stats */}
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
              <DealsPipelineStages apiData={overAllData?.deals_by_stage} apiLoading={overAllLoading} />

              <div className="grid grid-cols-2 gap-4">
                {!overAllLoading ? (
                  <>
                    <StatCard
                      icon={Clock}
                      iconBgColor="#BBF7D0"
                      iconColor={"#16A34A"}
                      title="Total Deals"
                      value={KPIData?.total_deals?.count}
                      progress={KPIData?.total_deals?.progress}
                      progressColor="bg-[#84CC16]"
                      trend={KPIData?.total_deals?.percentage}
                      trendUp={KPIData?.total_deals?.trendup}
                    />
                    <StatCard
                      icon={Today}
                      iconColor={'#FF7F50'}
                      iconBgColor="#FFEBE0"
                      title="Total Deal Amount"
                      value={`$${KPIData?.total_deal_amount?.count}`}
                      progress={KPIData?.total_deal_amount?.progress}
                      progressColor="bg-[#0095FF]"
                      trend={KPIData?.total_deal_amount?.percentage}
                      trendUp={KPIData?.total_deal_amount?.trendup}
                    />
                    <StatCard
                      icon={RoundArrowCircle}
                      iconColor={'#FF4040'}
                      iconBgColor="#FEE2E2"
                      title="Won Deal Amount"
                      value={`$${KPIData?.won_deal_amount?.count}`}
                      progress={KPIData?.won_deal_amount?.progress}
                      progressColor="bg-[#BF83FF]"
                      trend={KPIData?.won_deal_amount?.percentage}
                      trendUp={KPIData?.won_deal_amount?.trendup}
                    />
                    <StatCard
                      icon={RoundArrowCircle}
                      iconBgColor="#EDE9FE"
                      iconColor={'#6D28D9'}
                      title="Total Won Customers"
                      value={KPIData?.total_won_customers?.count}
                      progress={KPIData?.total_won_customers?.progress}
                      progressColor="bg-[#FF7F50]"
                      trend={KPIData?.total_won_customers?.percentage}
                      trendUp={KPIData?.total_won_customers?.trendup}
                    />
                    <StatCard
                      icon={Clander}
                      iconColor={'#335CFF'}
                      iconBgColor="#DBEAFE"
                      title="Conversion Rate"
                      value={KPIData?.conversion_rate?.count}
                      progress={KPIData?.conversion_rate?.progress}
                      progressColor="bg-[#0E121B]"
                      trend={KPIData?.conversion_rate?.percentage}
                      trendUp={KPIData?.conversion_rate?.trendup}
                    />
                    <StatCard
                      icon={Exit}
                      iconBgColor="#EDE9FE"
                      iconColor={'#6D28D9'}
                      title="Active Customers"
                      value={KPIData?.total_active_customers?.count}
                      progress={KPIData?.total_active_customers?.progress}
                      progressColor="bg-yellow-500"
                      trend={KPIData?.total_active_customers?.percentage}
                      trendUp={KPIData?.total_active_customers?.trendup}
                    />
                  </>
                ) :
                  (
                    Array.from({ length: 6 }).map((_, index) => (
                      // <div
                      //   key={index}
                      //   className="bg-white shadow rounded-xl p-4 animate-pulse"
                      // >
                      //   {/* Top row: label + icon */}
                      //   <div className="flex items-center justify-between mb-2">
                      //     <Skeleton variant="text" width={80} height={16} />
                      //     <Skeleton variant="circular" width={20} height={20} />
                      //   </div>
                      //   {/* Value row */}
                      //   <div className="flex items-center justify-between gap-2 mb-1 mt-2 py-[12px]">
                      //     <Skeleton variant="text" width={60} height={32} />
                      //     <Skeleton variant="rounded" width={40} height={20} />
                      //   </div>
                      //   {/* Sublabel */}
                      //   <Skeleton variant="text" width={80} height={12} />
                      // </div>
                      <StatsCardSkeleton />
                    ))
                  )
                }

              </div>
            </div>

            {/* Second Row */}
            <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
              <div className="xl:col-span-8">

                <ChartMainCard
                  Icon={<TeamAvailability />}
                  iconColor={'bg-[#FEE2E2] text-[#FF4040]'}
                  heading="Deal Performance Trends"
                  subHeading={"Monitor trends in won, lost, and total deals over time"}
                >
                  {!overAllLoading ?
                    <AreaLineChart chartData={chartData} apiLoading={overAllLoading} />
                    :
                    null
                  }
                </ChartMainCard>



              </div>
              <div className="xl:col-span-4">
                {/* <DealsByCountry apiData={overAllData?.deals_by_country} apiLoading={overAllLoading} /> */}
                <TodayFollowups
                  view={View}
                  loading={followUpsApiLoading}
                  leads={followUpsData?.todays_followup_list}
                  count={followUpsData?.todays_followup_count}
                />
              </div>
              {/* <div className="xl:col-span-4">
          <WonDealsStage />
        </div> */}

            </div>


            {/* Third Row */}
            <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-6">
              <div className="xl:col-span-4">
                {/* <DealsByStageChart apiData={overAllData?.deals_by_package} apiLoading={overAllLoading} /> */}
                <RecentDealsTable apiData={overAllData?.recent_deals} apiLoading={overAllLoading} />
              </div>
              <div className="xl:col-span-4">
                {/* <DealsByCompanies apiData={overAllData?.deals_by_brands} apiLoading={overAllLoading} /> */}
                <DealsByCompanies brandData={overAllData?.deals_by_brands} brandLoading={overAllLoading} />
              </div>
              <div className="xl:col-span-4">
                <TopDealsChart apiData={overAllData?.deals_by_product} apiLoading={overAllLoading} />
              </div>
            </div>

            {/* Fourth Row */}
            {/* <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
              <div className="xl:col-span-8 h-[350px] min-h-[520px]">
                <RecentDealsTable apiData={overAllData?.recent_deals} apiLoading={overAllLoading} />
              </div>

              <div className="xl:col-span-4">
                <RecentFollowUp apiData={overAllData?.followups} apiLoading={overAllLoading} />
              </div>
              <div className="xl:col-span-4">
          <RecentActivities />
        </div>
            </div> */}
          </div>

        </>
      ) :
        <InnerLoader />
      }

    </div>
  );
}
